"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const function_descriptor_1 = require("./function-descriptor");
exports.DslCompilerModuleSymbol = Symbol.for('DslCompilerModule');
function moduleFunction(name, outType, parameters, validate) {
    return {
        name,
        outType,
        parameters,
        validate
    };
}
exports.moduleFunction = moduleFunction;
function mapToFunctionDescriptor(ns, functions) {
    return functions.map(x => function_descriptor_1.func(ns, x.name, x.outType, x.parameters, x.validate));
}
exports.mapToFunctionDescriptor = mapToFunctionDescriptor;
//# sourceMappingURL=compiler-module.js.map